import { render } from "./VendorDetailsJobsTab.vue?vue&type=template&id=7392702c"
import script from "./VendorDetailsJobsTab.vue?vue&type=script&lang=js"
export * from "./VendorDetailsJobsTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__